import { Modal } from 'components';
import styled from 'styled-components';
import { from } from 'styles/mixins';

export const Container = styled(Modal)`
  & .MuiPaper-root {
    box-sizing: border-box;
    min-height: 100vh;
    padding: 2rem;
    overflow: hidden;

    ${from.mobileXL`
      max-width: 31.1875rem;
      min-height: unset;
    `};
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const Title = styled.h2`
  margin: 0 0 ${({ theme }) => theme.spacing.sm};
  font-size: 1.25rem;
  line-height: 1.5rem;
  font-weight: ${({ theme }) => theme.weights.bold};
  color: ${({ theme }) => theme.colors.primary};
`;

export const Paragraph = styled.p`
  margin: 0 0 1.625rem;
`;
